export var HarmonyThemeMode;
(function (HarmonyThemeMode) {
    HarmonyThemeMode["Contrast"] = "contrast";
    HarmonyThemeMode["Dark"] = "dark";
    HarmonyThemeMode["Light"] = "light";
    HarmonyThemeMode["System"] = "system";
})(HarmonyThemeMode || (HarmonyThemeMode = {}));
// TODO: Include other themes. Presently just have default 'Office'
export var HarmonyThemeId;
(function (HarmonyThemeId) {
    HarmonyThemeId["Office"] = "Office";
})(HarmonyThemeId || (HarmonyThemeId = {}));
//# sourceMappingURL=HarmonyTheme.js.map